import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from './date-format.pipe';
import { CurrencyFormatPipe } from './currency-format.pipe';

@NgModule({
  declarations: [
    DateFormatPipe,
    CurrencyFormatPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DateFormatPipe,
    CurrencyFormatPipe
  ]
})
export class PipesModule { }
